export enum HeaderOptionTypes {
  OPTIONS = 'OPTIONS',
  ACCESSIBILITY = 'ACCESSIBILITY'
}

export enum HeaderButtonType {
  PLANNED = 'planned-documents',
  PARTICIPATION = 'participation-budget',
  GEOPRODUCT = 'geoproduct',
}
